import * as React from "react";
import SearchBar, { SearchBarProps } from "./SearchBar";
import "./HeaderBar.scss";
import { AvailableEntitiesSettings } from "../model/EntitySettings";
import Dropdown from "./dropdown/Dropdown";

interface HeaderBarProps {
  title: string;
  breadcrumb?: Breadcrumb;
  action?: React.ReactElement;
  searchConfiguration?: SearchBarProps;
  entities?: AvailableEntitiesSettings;
  onChange?: () => void;
}

export interface Breadcrumb {
  title: string;
  link: string;
}

export default function HeaderBar(props: HeaderBarProps) {
  return (
    <div
      className={
        "header-bar h-flex align-center space-between no-wrap" +
        (props.breadcrumb ? " smaller-padding" : "")
      }
    >
      <div className="h-flex with-margins">
        <div className="v-flex">
          {props.breadcrumb && (
            <a className="breadcrumb" href={props.breadcrumb.link}>
              {props.breadcrumb.title}
            </a>
          )}
          <div className={props.breadcrumb ? "title-with-breadcrumb" : "header-bar-title"}>
            {props.title}
          </div>
        </div>
        {props.searchConfiguration && <SearchBar {...props.searchConfiguration} />}
      </div>
      {props.action}
      {props.entities && props.entities.availableEntities.length > 1 && (
        <div className="entities-dropdown">
          <Dropdown
            multipleChoices={false}
            options={props.entities.availableEntities.map((entity) => {
              return {
                name: entity.displayName,
                value: entity.entitySettingsId.value,
              };
            })}
            defaultValue={{
              name: props.entities.selectedEntity.displayName,
              value: props.entities.selectedEntity.entitySettingsId.value,
            }}
            onChange={(entitySettingsUId) => {
              // Reload page by adding the selected entity
              const currentUrl = window.location.href;
              const searchParams = new URLSearchParams(window.location.search);
              searchParams.set("selected_entity", entitySettingsUId);
              props.onChange && props.onChange();
              window.location.href =
                currentUrl.split("?")[0].split("#")[0] + "?" + searchParams.toString();
            }}
          />
        </div>
      )}
    </div>
  );
}
